import React from 'react';
import styled from 'styled-components';

const Title = styled.div`
  text-align: center;
  font-family: 'Oswald';
  h2 {
    font-size: 42px;
    text-transform: uppercase;
  }
  p {
    font-size: 18px;
    font-family: 'OCRoboto';
  }
`;

export default ({ title, tagLine }) => (
  <Title>
    <h2>{title}</h2>
    <p>{tagLine}</p>
  </Title>
);
